import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Canonical tracker entry point. Sends visitors and crawlers to the existing
 * exam preparation page so there is a single indexable page per exam.
 */
export const Route = createFileRoute("/tracker/jee-main")({
  beforeLoad: () => {
    throw redirect({ to: "/jee", statusCode: 301 });
  },
});
